module.exports = __webpack_public_path__ + "static/media/Old-Paper-Tags.f049cd4b.jpg";